import { render, staticRenderFns } from "./roleManage.vue?vue&type=template&id=0f1abadf&scoped=true"
import script from "./roleManage.js?vue&type=script&lang=js&external"
export * from "./roleManage.js?vue&type=script&lang=js&external"
import style0 from "./roleManage.vue?vue&type=style&index=0&id=0f1abadf&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0f1abadf",
  null
  
)

export default component.exports